import React from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Create, Add, Close, Assignment } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import ModalSaleForceCanal from './Modal';
import { useModal } from 'hooks/useModal';
import { WithApp } from 'contexts/appContext';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Cód. Canal', accessor: 'base_canal_code' },
  { Header: 'Canal', accessor: 'base_canal_description' },
  { Header: 'Lista precio', accessor: 'ListName' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function SaleForceDetail(props) {
  const classes = useStyles();

  const { id, showNotify, sfCanals, reload } = props;
  const [model, setOpen] = useModal();

  return (
    <GridItem xs={12}>
      <GridContainer>
        <ModalSaleForceCanal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={reload}
          idSaleForce={id}
        />

        <GridItem xs={12}>
          <Card>
            <CardHeader icon>
              <AllowedGuard
                permission={ConstantPermissions.BASE_SALE_FORCE_CANALS_STORE}
                component={
                  <CardIcon color="primary">
                    <Assignment style={{ color: 'white' }} />
                  </CardIcon>
                }
              >
                <CardIcon
                  onClick={() => setOpen({})}
                  pointer="true"
                  color={props.themeContext.buttonColorSuccess}
                >
                  <Add />
                </CardIcon>
              </AllowedGuard>
              <h4 className={classes.cardIconTitle}>Listado Fuerza de Ventas Canales</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                excelName="Fuerza-de-venta-canal"
                defaultWidth={900}
                indexRow={[0, 1, 4, 5]}
                widthRow={[130, 120, 120, 0]}
                columns={columns}
                data={sfCanals?.map((item, i) => {
                  return {
                    num: (
                      <div className="actions-right">
                        {i + 1}
                        <AllowedGuard
                          permission={ConstantPermissions.BASE_SALE_FORCE_CANALS_UPDATE}
                        >
                          <Button
                            justIcon
                            round
                            simple
                            color="info"
                            className="like"
                            onClick={() => setOpen(item)}
                          >
                            <Create />
                          </Button>
                        </AllowedGuard>
                        <AllowedGuard
                          permission={ConstantPermissions.BASE_SALE_FORCE_CANALS_DELETED}
                        >
                          <Button
                            justIcon
                            round
                            simple
                            onClick={() => {
                              props.confirm('base/sale-force-canal', item.id, reload);
                            }}
                            color={props.themeContext.buttonColorDanger}
                            className="remove"
                          >
                            <Close />
                          </Button>
                        </AllowedGuard>
                      </div>
                    ),
                    base_canal_code: item.base_canal_code,
                    base_canal_description: item.base_canal_description,
                    ListName: item.ListName,
                    state: item.state === 'A' ? 'Activo' : 'Inactivo',
                    actions: ''
                  };
                })}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </GridItem>
  );
});
